<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.polls', 2),
                        href: meta.links.index,
                    },
                    {
                        name: $t('messages.edit'),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.store" method="post" @submit.prevent="submit">
            <TitleFieldsFormSection>
                <template v-slot:title>
                    {{ $t('messages.information') }}
                </template>
                <div class="md:grid md:grid-cols-6 md:gap-6">
                    <div class="sm:col-span-4">
                        <div class="mt-1">
                            <FormLabel :value="$tc('messages.questions', 1)" for="question" />
                            <FormInput
                                required
                                id="question"
                                v-model="form.question"
                                name="question"
                                type="text"
                                class="mt-1 w-full"
                            />
                            <FormError :value="form.errors.question" class="mt-2" />
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>

            <div class="flex justify-end">
                <AppButton desired-action element="button" type="submit" :disabled="form.processing">
                    {{ $t('messages.save') }}
                    <span v-if="form.processing" class="ml-1 btn-spinner"></span>
                </AppButton>
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import AppButton from '@/components/AppButton.vue';

export default {
    components: {
        AppButton,
        PanelPage,
        TitleFieldsFormSection,
        FormInput,
        FormLabel,
        FormError,
    },
    layout: Layout,
    name: 'Create',
    props: ['meta', 'smileyPollQuestion'],
    data() {
        return {
            form: this.$inertia.form({
                question: this.smileyPollQuestion.question,
            }),
        };
    },
    methods: {
        submit() {
            this.form.patch(this.meta.links.update);
        },
    },
};
</script>
